import { tracs_api } from "../../services/api.interceptor";
import { StationUpdate } from "../interfaces/sharedmodels";

class MasterListService{

    getMasterLists(){
        let toc=null;

        let tocfromStorage=localStorage.getItem('Toc');
        if(tocfromStorage){
            toc=JSON.parse(tocfromStorage);
        }
        return tracs_api
        .post(process.env.REACT_APP_DATAMANAGEMENT_API+ "MasterList/GetMasterLists?tocId="+(toc?toc?.Id:0));
    }
    getItems(typeId:number){
        let toc=null;

        let tocfromStorage=localStorage.getItem('Toc');
        if(tocfromStorage){
            toc=JSON.parse(tocfromStorage);
        }
        return tracs_api
        .post(process.env.REACT_APP_DATAMANAGEMENT_API+ "MasterList/GetItems",{TypeId:typeId,TocId:(toc?toc?.Id:0)});
    }
    updateMasterList(data:any){
        let toc=null;
        let tocfromStorage=localStorage.getItem('Toc');
        if(tocfromStorage){
            toc=JSON.parse(tocfromStorage);
            data.TocId=toc.Id;
        }
        else{
            data.TocId=0;
        }

        return tracs_api
        .post(process.env.REACT_APP_DATAMANAGEMENT_API+ "MasterList/UpdateMasterlist",data);
    }

    getTableVersions(magNlcId:string,itsoNlcId:string){
        return tracs_api
        .post(process.env.REACT_APP_DATAMANAGEMENT_API+"Lookup/GetTableVersions?itsoNlcId="+itsoNlcId+"&magneticNlcId="+magNlcId);
    }

    updateStation(data:StationUpdate){
        let toc=null;
        let tocfromStorage=localStorage.getItem('Toc');
        if(tocfromStorage){
            toc=JSON.parse(tocfromStorage);
            data.TocId=toc.Id;
        }
        else{
            data.TocId=0;
        }
        return tracs_api
        .post(process.env.REACT_APP_DATAMANAGEMENT_API+ "MasterList/UpdateStation",data);
    }
}

export default new MasterListService();